import { render, staticRenderFns } from "./SignupLinks.vue?vue&type=template&id=245e7038"
import script from "./SignupLinks.vue?vue&type=script&lang=js"
export * from "./SignupLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports